<template>
<div>
  <site-header />
  <extra-health-plans />
  <site-footer />
</div>
</template>

<script>
import SiteHeader from "../../components/SiteHeader";
import SiteFooter from "../../components/SiteFooter";
import ExtraHealthPlans from "./ExtraHealthPlans";
import {allowedDomains, host, siteUrl} from "../../config/config";
import Api from "../../includes/Api";
export default {
name: "ExtrahealthHomePage",
  components:{
    SiteHeader,
    SiteFooter,
    ExtraHealthPlans
  },
  mounted() {
   let app = this
    app.landing_type = window.localStorage.getItem('open_type');
    app.fetchGroupInfo();
  },
  methods: {
    fetchGroupInfo() {
      let app = this
      if ((allowedDomains.includes(host) && app.landing_type == 'agent' && app.$route.params.landing) || (allowedDomains.includes(host)  && app.landing_type == 'group' && app.$route.params.landing)) {
        Api.get('/get-domainSite-infromation?site_domain=' + window.btoa(unescape(encodeURIComponent(siteUrl)))).then((response) => {
          if (response.data.statusCode == 200) {
            if (app.landing_type !== 'group') {
              window.localStorage.setItem('group_id', response.data.data.gid);
            }
            window.localStorage.setItem('portal_id', response.data.data.gid);
            window.localStorage.setItem('enroll_type', 'new-group-member');
            app.$bus.$emit('getMenuList');
            app.$bus.$emit('getGroupDetail');
            app.$bus.$emit('getRecommendedList')
            app.$bus.$emit('renderZipCode')
            app.$bus.$emit('renderPlanList')
            // app.$router.push('/');
          }
        }).catch(() => {
          app.$router.push('/404');
        })
      }
    },
    }
}
</script>

<style scoped>

</style>